export enum DutyOfCareSubscriptionPackageType {
  Lite = 'Lite',
  Regular = 'Regular',
  StudyAbroad = 'StudyAbroad',
  CorporateFamilyAddOn = 'CorporateFamilyAddOn',
  NonDocClient = 'NonDocClient',
}
